<template>
  <div v-if="shouldRender" :class="{'field-disabled': isDisabled && !hideIfNoAccess}">
    <slot :disabled="isDisabled" :hidden="!shouldRender"></slot>
  </div>
</template>

<script>
import PermissionService from '@/services/PermissionService';

export default {
  name: 'VFieldPermission',
  props: {
    domain: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    action: {
      type: String,
      default: null
    },
    actions: {
      type: [String, Array],
      default: () => 'write'
    },
    mode: {
      type: String,
      default: 'any',
      validator: value => ['any', 'all'].includes(value)
    },
    hideIfNoAccess: {
      type: Boolean,
      default: false
    },
    // Nueva propiedad para obtener la configuración externa de campos
    config: {
      type: Object,
      default: () => ({})
    },
    // Por defecto los campos están habilitados
    defaultEnabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    actionsToCheck() {
      return this.actions || this.action || 'write';
    },
    
    isDisabled() {
      return PermissionService.isFieldDisabled(
        this.domain, 
        this.field,
        this.actionsToCheck
      );
    },
    
    // Determina si el campo debe renderizarse en base al config y permisos
    shouldRender() {
      // Si está deshabilitado por permisos y se debe ocultar
      if (this.isDisabled && this.hideIfNoAccess) {
        return false;
      }
      
      // Si existe una configuración específica para este campo
      if (this.config && this.field in this.config) {
        // Usar el valor de habilitado de la configuración
        return this.config[this.field].enabled !== false;
      }
      
      // Si no hay configuración específica, usar el valor por defecto
      return this.defaultEnabled;
    }
  }
}
</script>

<style scoped>
.field-disabled {
  opacity: 0.6;
  pointer-events: none;
}
</style>
